<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    hide-details
    item-text="title"
    item-value="id"
    label="Поставка*"
    placeholder="Введите номер поставки"
    return-object
    height="44"
    outline
    clearable
    required
    :rules="[(v) => !!v || '']"
    @focus="getData"
    @input="changeShipping"
  />
</template>

<script>
import { getReleaseOrdersShippingsByName } from "../../../backend/releaseOrdersApi.js";

export default {
  props: ["value", "clientId", "senderId"],
  data() {
    return {
      items: [],
      loading: false,
      selected: null,
      search: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.selected = val;
        if (val) {
          this.items.push(val);
        }
      },
      immediate: true,
    },
    search(val) {
      if (this.loading) {
        return;
      }
      if (this.loading && this.selected.title === val) {
        return;
      }

      if (!this.loading && this.selected && this.selected.title === val) {
        return;
      }

      if (val) {
        this.getData();
      } else {
        this.items = [];
        this.selected = null;
      }
    },
  },
  methods: {
    getData() {
      setTimeout(async() => {
        await this.getShippingsByName();
      }, 1000);
    },
    async getShippingsByName() {
      this.loading = true;
      const filter = {
        number: this.search,
        clientId: this.clientId ? this.clientId : "",
        senderId: this.senderId ? this.senderId : "",
      };
      const shippings = await getReleaseOrdersShippingsByName(filter);
      this.items = shippings;
      this.loading = false;
    },
    changeShipping() {
      this.$emit("input", this.selected);
    },
  },
};
</script>
